export class TopPanelConstants {
	public static readonly FILTER_KEYS = {
		dateFilter: {
			key: 'TOP_PANEL_DATE_FITLER_LABEL',
			label: 'Date Updated'
		},
		azFilter: {
			key: 'TOP_PANEL_AZ_FITLER_LABEL',
			label: 'A-Z'
		}
	};

	public static readonly TITLE_KEY = 'TOP_PANEL_TITLE';

	public static readonly TITLE_ICON_KEY = 'TOP_PANEL_TITLE_ICON';
	public static readonly TITLE_ICON = 'file-text-o';

	public static readonly FILTER_TEXT_KEY = 'TOP_PANEL_FILTER_TEXT';
	public static readonly FILTER_TEXT_LABEL = 'Sort By';

	public static readonly BUTTON_LABEL_KEY = 'TOP_PANEL_BUTTON_LABEL';
	public static readonly BUTTON_LABEL_LABEL = 'Manage';
}
